export default __webpack_public_path__ + "static/media/3.dd83aa1d.jpg";